<template>
  <base-button class="btn-dark" :text="text" @click="windowOpen" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'NewWindowButton',
  components: {
    BaseButton,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    windowUrl: {
      type: String,
      required: true,
    },
    windowName: {
      type: String,
      required: false,
      default: null,
    },
    windowWidth: {
      type: Number,
      required: true,
    },
    windowHeight: {
      type: Number,
      required: true,
    },
    imageURL: {
      type: String,
      required: false,
      default: null,
    }
  },
  methods: {
    windowOpen() {
      // スクリーン左上にウィンドウを配置
      return window.open(this.windowUrl, this.windowName, "width=" + this.windowWidth + ",height=" + this.windowHeight + ",left=" + 0 + ",top=" + 0);
    },
  },
}
</script>
